export default __webpack_public_path__ + "static/media/prototypePart2.4a7ede02.png";